import type { FC } from 'react';

import type { TIconProps } from './icon.props';

const IconEyeOff: FC<TIconProps> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.06667"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M2 8C2 8 4.13333 4 8 4C11.8667 4 14 8 14 8C14 8 11.8667 12 8 12C4.13333 12 2 8 2 8Z"
    />
    <path
      d="M8 9.73333C8.95729 9.73333 9.73333 8.95729 9.73333 8C9.73333 7.04271 8.95729 6.26667 8 6.26667C7.04271 6.26667 6.26667 7.04271 6.26667 8C6.26667 8.95729 7.04271 9.73333 8 9.73333Z"
    />
    <path
      d="M3.66667 3L12.3333 13"
    />
  </svg>
);

export {
  IconEyeOff,
};
